module.exports = __webpack_public_path__ + "static/media/52.ad5c499e.png";